import { SisetuResult } from 'interface/sisetu'

import { Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material'

import { SisetuPreview } from '../../preview'

type SisetuPreviewDialogProps = {
  sisetuList?: SisetuResult[]
  sisetu?: SisetuResult
  sisetuCode: string
  onSisetuOpen?: (sisetuCode: string | null) => void
  onKojinOpen?: (kojinCode: string | null) => void
  onAuthorOpen?: (authorId: number | null) => void
  onClose: () => void
}
export const SisetuPreviewDialog = ({
  sisetuList,
  sisetu,
  sisetuCode,
  onSisetuOpen,
  onKojinOpen,
  onAuthorOpen,
  onClose
}: SisetuPreviewDialogProps) => {
  const theme = useTheme()
  const isSmallMedia = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <Dialog
      open
      fullScreen={isSmallMedia}
      maxWidth='xl'
      fullWidth
      onClose={() => onClose()}
      aria-labelledby="sisetu-preview-dialog"
    >
      <DialogContent
        sx={{
          height: '90vh',
          width: '100%',
          boxSizing: 'border-box',
          padding: 0,
        }}
      >
        <SisetuPreview
          sisetuList={sisetuList}
          sisetu={sisetu}
          sisetuCode={sisetuCode}
          onSisetuOpen={onSisetuOpen}
          onKojinOpen={onKojinOpen}
          onAuthorOpen={onAuthorOpen}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  )
}
